export default {"src":"/_next/static/media/icon-tutorial.cb9c67b4.svg","height":14,"width":14};